import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiDiv = (_param)=>{
    var { biData, innerRef, stopPropagation } = _param, rest = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }, rest));
};
BiDiv.displayName = 'BiDiv';
export default BiDiv;

//# sourceMappingURL=BiDiv.js.map